import htmlDiff from './htmlDiff'

export default htmlDiff as (before: string, after: string) => string
